
import { Component, Vue } from 'vue-property-decorator'
import {
  getMerchantsGroupList,
  GetOrganizationInfoAll
} from '@/api/customerManage'
import { Getter } from 'vuex-class'
import AreaPopup from '@/views/dataReport/template/AddrPopup.vue'

@Component({
  name: 'KPIMoreFilter',
  components: { AreaPopup }
})
export default class KPIMoreFilter extends Vue {
  show = false

  params = {
    deptId: '', //部门id
    employeeName: '', // 员工姓名
    orderType: '', //  下单方式
    customerGroup: '' // 客户类别
  }

  depList = []

  orderTypeOptions = [
    { text: '全部', value: '' },
    { text: '代下单', value: 2 },
    { text: '自主下单', value: 1 }
  ]

  /**
   * 显示或关闭更多筛选
   */
  showModel() {
    this.show = true
  }

  goodsTypeOptions = [
    { text: '按商品名称统计', value: '1' },
    { text: '按商品品牌统计', value: '2' },
    { text: '按商品分类统计', value: '3' }
  ]

  groupList = [
    {
      groupId: '',
      groupName: '全部分组'
    }
  ]

  created() {
    this.getDepList()
    this.getGroupList()
  }

  /**
   * 获取客户分组列表
   */
  getDepList() {
    GetOrganizationInfoAll({}).then((res: any) => {
      this.depList = res.data
      this.depList.forEach((item) => {
        if (item.isEnabled === '0' || item.orgType === '1') {
          item.disabled = true
        }
      })
      this.params.deptId = this.depList[0].orgId
    })
  }

  /**
   * 获取客户分组列表
   */
  getGroupList() {
    getMerchantsGroupList({}).then((res: any) => {
      console.log('res', res)

      this.groupList = this.groupList.concat(res.data.groupList || [])
      this.params.customerGroup = this.groupList[0].groupId
    })
  }

  /**
   * @description: 下单方式选择事件
   */
  handleOrderTypeOptions(type) {
    this.params.orderType = type
  }

  /**
   * @description: 部门选择事件
   */
  handleDeptOptions(type, levelIds) {
    this.params.deptId = type
  }

  /**
   * @description: 客户分组选择事件
   */
  handleGroupOptions(type) {
    this.params.customerGroup = type
  }
  /**
   * 取消
   */
  cancel() {
    this.show = false
    this.$emit('cancel')
  }

  /**
   * 重置
   */
  resetFunc() {
    this.params.orderType = ''
    this.params.employeeName = ''
    this.params.customerGroup = ''
    this.params.deptId = this.depList[0].orgId
  }

  /**
   * 确认
   */
  confirm() {
    this.show = false
    this.$emit('load', this.params)
  }
}
